export const getSchema = (schema?: string): string => {
    if (schema) {
        return schema;
    }

    const location = window && window.location ? window.location : { protocol: '' };

    return location.protocol;
};
